var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectivityEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#B1CBD9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D0E0E8",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6665 26.9333C23.6665 24.9732 23.6665 23.9931 24.048 23.2444C24.3835 22.5858 24.919 22.0504 25.5775 21.7148C26.3262 21.3333 27.3063 21.3333 29.2665 21.3333H33.0136C33.8696 21.3333 34.2977 21.3333 34.7005 21.43C35.0576 21.5158 35.399 21.6572 35.7122 21.8491C36.0654 22.0655 36.368 22.3682 36.9734 22.9735L40.693 26.6931C41.2983 27.2985 41.601 27.6011 41.8174 27.9543C42.0093 28.2675 42.1507 28.6089 42.2365 28.966C42.3332 29.3688 42.3332 29.7969 42.3332 30.6529V39.0667C42.3332 41.0269 42.3332 42.007 41.9517 42.7556C41.6161 43.4142 41.0807 43.9496 40.4221 44.2852C39.6734 44.6667 38.6934 44.6667 36.7332 44.6667H29.2665C27.3063 44.6667 26.3262 44.6667 25.5775 44.2852C24.919 43.9496 24.3835 43.4142 24.048 42.7556C23.6665 42.007 23.6665 41.0269 23.6665 39.0667V26.9333Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3332 35.1C28.3332 34.7733 28.3332 34.61 28.3968 34.4852C28.4527 34.3754 28.5419 34.2862 28.6517 34.2303C28.7765 34.1667 28.9398 34.1667 29.2665 34.1667H36.7332C37.0599 34.1667 37.2232 34.1667 37.348 34.2303C37.4578 34.2862 37.547 34.3754 37.6029 34.4852C37.6665 34.61 37.6665 34.7733 37.6665 35.1V39.0667C37.6665 39.3934 37.6665 39.5567 37.6029 39.6815C37.547 39.7913 37.4578 39.8805 37.348 39.9364C37.2232 40 37.0599 40 36.7332 40H29.2665C28.9398 40 28.7765 40 28.6517 39.9364C28.5419 39.8805 28.4527 39.7913 28.3968 39.6815C28.3332 39.5567 28.3332 39.3934 28.3332 39.0667V35.1Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectivityEmpty);
export default __webpack_public_path__ + "static/media/connectivityEmpty.4c4975946decd2ab712cc4db211af652.svg";
export { ForwardRef as ReactComponent };